module.exports = __webpack_public_path__ + "img/btn_left.e3557f6d.jpg";